import { defineTokens } from '@chakra-ui/react';

export const gradientsTokens = defineTokens({
  gradients: {
    simple: { value: 'linear-gradient(to right, #221EAF, #9490FF)' },
  },
});
